import request from '@/utils/request'

export function commonInfo() {
  return request({
    url: '/website/v1/api/commonInfo',
    method: 'get'
  })
}

export function index() {
  return request({
    url: '/website/v1/api/index',
    method: 'get'
  })
}

export function decorateInfo() {
  return request({
    url: '/website/v1/api/decorate',
    method: 'get'
  })
}

export function employee(type, page) {
  return request({
    url: '/website/v1/api/employee',
    method: 'get',
    params: { type, page }
  })
}

export function perFinIndex() {
  return request({
    url: '/website/v1/api/perFinIndex',
    method: 'get'
  })
}

export function bankCardIndex() {
  return request({
    url: '/website/v1/api/bankCardIndex',
    method: 'get'
  })
}

export function corFinIndex() {
  return request({
    url: '/website/v1/api/corFinIndex',
    method: 'get'
  })
}

export function eleBankIndex() {
  return request({
    url: '/website/v1/api/eleBankIndex',
    method: 'get'
  })
}

export function calcRules() {
  return request({
    url: '/website/v1/api/calcRules',
    method: 'get'
  })
}

export function imgVlCd() {
  return request({
    url: '/website/v1/api/imgVlCd',
    method: 'get'
  })
}


export function area() {
  return request({
    url: '/website/v1/api/area',
    method: 'get'
  })
}

export function career() {
  return request({
    url: '/website/v1/api/career',
    method: 'get'
  })
}
